import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import PageShell from "../components/PageShell";
import Hero from "../components/Hero";
import { Approach } from "../components/Content3";
import { Contact } from "../components/Contact";
import { Section, Reveal } from "../lib/ui";

const ABOUT_IMG = "https://images.unsplash.com/photo-1531819177115-428566ccfb50?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
const SERVICES_IMG = "https://images.unsplash.com/photo-1712567604499-08f207054260?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

function LinkCard({ img, overline, title, desc, to, testid }) {
  const navigate = useNavigate();
  return (
    <Reveal>
      <button onClick={() => navigate(to)} className="group relative block w-full text-left rounded-2xl overflow-hidden hairline h-[340px]" data-testid={testid}>
        <img src={img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-all duration-700" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/20" />
        <div className="relative h-full flex flex-col justify-end p-8">
          <div className="overline text-gold mb-3">{overline}</div>
          <h3 className="font-display font-light text-3xl md:text-4xl text-white">{title}</h3>
          <p className="mt-3 text-silver/70 font-body font-light text-sm max-w-md">{desc}</p>
          <span className="mt-5 inline-flex items-center gap-2 text-sm font-body text-gold group-hover:gap-3 transition-all duration-300">
            Explore <ArrowUpRight size={16} />
          </span>
        </div>
      </button>
    </Reveal>
  );
}

export default function HomePage() {
  return (
    <PageShell>
      <Hero />
      <Approach />
      <Section id="explore" className="bg-ink-surface">
        <div className="grid md:grid-cols-2 gap-6">
          <LinkCard img={ABOUT_IMG} overline="Who We Are" title="About Arco Orbis2" desc="Our company, our approach and the two partners who lead every engagement." to="/about" testid="home-link-about" />
          <LinkCard img={SERVICES_IMG} overline="What We Do" title="Our Services" desc="Bespoke security, risk management, technical solutions and travel risk — explore each area." to="/services" testid="home-link-services" />
        </div>
      </Section>
      <Contact />
    </PageShell>
  );
}
